import {Fetch} from "./Fetch";

export class ProfileAPI {

    static async createInvestorProfile(payload){
        return await Fetch('POST', 'api/users/investor/', payload);
    }

    static async createStartupProfile(payload){
        return await Fetch('POST', 'api/users/startup/', payload);
    }

    static async updateStartupProfile(payload){
        return await Fetch('PUT', 'api/users/startup/update_profile/', payload);
    }

    static async updateInvestorProfile(payload){
        return await Fetch('PUT', 'api/users/investor/update_profile/', payload);
    }

    static async getStartupProfile(){
        return await Fetch('GET', 'api/users/startup/details/');
    }

    static async getInvestorProfile(){
        return await Fetch('GET', 'api/users/investor/details/');
    }

}
/*

 In development: The product is not usable yet.




 */
ProfileAPI.STARTUP_STAGE = ["Concept stage: haven't started developing the product.",
                            'In development: The product is not usable yet.',
                            'First product ready, but no users yet.',
                            'Product launched with at least one free user.',
                            'Revenue stage, at least one paying user.',
                            'Revenue generating for at least the past 2 years.'];
ProfileAPI.ENTERPRISE_STAGE = ['Angel Investor', 'Accelerator', 'Incubator', 'VC', 'NGO'];
ProfileAPI.INVESTOR_STAGE = ['Angel', 'Seed', 'Pre-seed', 'Series A', 'Series B', 'Series C', 'IPO (Initial Public Offering)'];
ProfileAPI.STARTUP_FUNCTIONS = ['Angel', 'Seed', 'Pre-seed', 'Series A', 'Series B', 'Series C', 'IPO (Initial Public Offering)'];
ProfileAPI.INVESTOR_FUNCTIONS = ['Investment', 'Mentorship', 'Expansion & networking'];
ProfileAPI.INVESTMENT_RANGES = ['Below $100,000', '$100,000 - $500,000', '$500,000 - $1 Million', '$1 - $2 Million', '$2 - $3 Million', '$3 - 4 Million', 'More than $4 Million', 'We don\'t make cash investments.']
ProfileAPI.PORTFOLIO_SIZE = ['Less than 10' , '10 - 50' , '50 - 100', '100 - 200', '200 - 500', 'More than 500']


